import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const getSchedule = () =>
  axios({
    url: `${config.endpoints.schedules}?schedules=officeSchedule`,
    method: 'get',
    headers: getHeaders(true),
  })

const saveSchedule = (data) =>
  axios({
    url: config.endpoints.schedules,
    method: 'post',
    data,
    headers: getHeaders(true),
  })

export default {
  getSchedule,
  saveSchedule
}